export enum KEYS {
  TOKEN = 'authorizationClient',
  HACIENDA = 'authorizationHacienda',
  GATEWAY = 'authorizationGateway',
  ID_CLIENT = 'idClient',
  EMAIL_CLIENT = 'emailClient',
  NAME_CLIENT = 'nameClient',
  FLAG_VERIFY_VIEW = 'flagVerify',
  USERNAME_CLIENTE = 'usernameClient',
  USERNAME_CLIENTE_RESTORE = 'usernameClientRestore',
  ROL = 'rol',
  CODIGO_EMPRESA = 'code',
  LOGO_EMPRESA = 'logo',
  LIMITE_FACTURAR = 'limite_facturar',
  INTERNO = 'interno',
  DOCUMENTO_DUI_ID = '13',
  MESSAGE_SESSION_ERROR = '400',
  LIMITAR_USO_FELES = '300',
  COMPROBANTE = 'cpbase64',
  
  
}

export const VERSION = '211'